import React from "react";

export function HeroRequest({ singlePackage }: { singlePackage: boolean }) {
	if (singlePackage) {
		return null;
	}

	return (
		<div className="hero__request well well--inverted grid">
			<div className="request grid__col-12 grid__col-sm-7">
				<p className="title">
					Need more than one account? Choose a team plan
				</p>
				<div className="description">
					Give your entire team access to ch-aviation news and make
					sure they are always in the loop.
				</div>
				<a
					className="btn btn--primary w-min-20"
					href="mailto:sales@ch-aviation.com"
				>
					Send a request
				</a>
			</div>
			<div className="features typography grid__col-12 grid__col-sm-5">
				<p className="title">Special features:</p>
				<ul className="ticks ticks--small">
					<li>Multiple accounts</li>
					<li>Multi-year contracts</li>
					<li>Custom pricing</li>
				</ul>
			</div>
		</div>
	);
}
